import { subscriptionService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { IApiRequest, IMiDaySettingsResponse } from "@miplatform/types";
import { useState } from "react";

export const useMiDaySettings = () => {
  const [miDaySettings, setMiDaySettings] = useState<IMiDaySettingsResponse>();
  const [refresh, setRefresh] = useState(false);

  const stateManager = useComponentState();

  const getMiDaySettings = ({ id: subscriptionId }: IApiRequest = {}) => {
    return stateManager.run(async () => {
      const response = await subscriptionService.subscriptions.get(subscriptionId);
      setMiDaySettings(response.data);
      return response;
    });
  };

  const handleUpdateMiDaySetting = (data: Partial<IMiDaySettingsResponse>) => {
    return stateManager.run(async () => {
      const response =
        await subscriptionService.subscriptions.updateMiDaySettings({
          data,
          toastMessageConfig: {
            success: {
              text: `MiDay settings were updated successfully.`,
            },
            failure: {
              text: `Failed to update MiDay settings.`,
            },
          },
        });
      if (response.status === HTTP_STATUSES.OK) {
        setRefresh((prev) => !prev);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    getMiDaySettings,
    miDaySettings,
    setMiDaySettings,
    handleUpdateMiDaySetting,
    refresh,
    setRefresh,
  };
};
